import { render, staticRenderFns } from "./PageForStaff.vue?vue&type=template&id=01c7acc5&scoped=true&"
import script from "./PageForStaff.vue?vue&type=script&lang=js&"
export * from "./PageForStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c7acc5",
  null
  
)

export default component.exports